package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeOriginRefEntityType(private val literal: String) : IEnumType {
	Book("Book"),
	Content("Content");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_origin_ref_entity_type"}
	override fun getLiteral(): String {return literal}
}
